import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import Chip from 'ui/Chip';
import InfoTooltip from 'components/shared/InfoTooltip';
import IncompleteAssessmentSection from './IncompleteAssessmentSection';
import { invalidAssessmentError } from './helpers.js';

const KeywordMatchingSection = ({ assessmentData, assessmentError }) => {
  const correctWords = () => {
    return assessmentData?.formattedAssistedGrade?.keywordAnalysis?.correct.map(
      word =>
        word.used && (
          <Chip
            value={word.keyword}
            variant="success"
            iconLeft="check"
            size="large"
            customClassName="mr-8 mb-8"
          />
        ),
    );
  };

  const incorrectWords = () => {
    return assessmentData?.formattedAssistedGrade?.keywordAnalysis?.incorrect.map(
      word =>
        word.used && (
          <Chip
            value={word.keyword}
            variant="error"
            iconLeft="x"
            size="large"
            customClassName="mr-8 mb-8"
          />
        ),
    );
  };

  const correctWordsFound = () => {
    const correctWordsArray =
      assessmentData?.formattedAssistedGrade?.keywordAnalysis?.correct.map(
        word => word.used,
      );

    return correctWordsArray?.includes(true) ? (
      <div className="d-f fd-r fw-w">{correctWords()}</div>
    ) : (
      <div className="ml-16">
        <Text className="fs-i" variant={TEXT_VARIANTS.BODY}>
          {t('automated_analysis.keyword_matching.no_keywords_found')}
        </Text>
      </div>
    );
  };

  const incorrectWordsFound = () => {
    const incorrectWordsArray =
      assessmentData?.formattedAssistedGrade?.keywordAnalysis?.incorrect.map(
        word => word.used,
      );

    return incorrectWordsArray?.includes(true) ? (
      <div className="d-f fd-r fw-w">{incorrectWords()}</div>
    ) : (
      <div className="ml-16">
        <Text className="fs-i" variant={TEXT_VARIANTS.BODY}>
          {t('automated_analysis.keyword_matching.no_keywords_found')}
        </Text>
      </div>
    );
  };

  return (
    <div className="border-solid border border-gray-light bdrs-small mt-24 mb-16 p-16">
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="mb-16">
          {t('automated_analysis.keyword_matching.title')}
        </Text>

        <InfoTooltip
          className="pl-4 mt-4 tooltip-fixedWidth c-gray-light"
          tooltip={t(
            'automated_analysis.keyword_matching.tooltip_grading_station',
          )}
        />
      </div>
      {assessmentData.assistedGradingStatus !== 'complete' && (
        <IncompleteAssessmentSection
          status={assessmentData.assistedGradingStatus}
          error={assessmentError}
          processText={t('automated_analysis.keyword_matching.title')}
          invalidAssessmentError={invalidAssessmentError(assessmentData)}
        />
      )}
      {assessmentData.assistedGradingStatus === 'complete' && (
        <>
          <div className="mb-16 d-f fd-c">
            <Text
              variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
              className="mb-12"
            >
              {t('automated_analysis.keyword_matching.correct_keywords_label')}
            </Text>
            <div className="d-f fd-r fw-w">{correctWordsFound()}</div>
          </div>
          <div className="d-f fd-c">
            <Text
              variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
              className="mb-12"
            >
              {t(
                'automated_analysis.keyword_matching.incorrect_keywords_label',
              )}
            </Text>
            <div className="d-f fd-r fw-w">{incorrectWordsFound()}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default KeywordMatchingSection;
